import { jsx as _jsx } from "react/jsx-runtime";
import MUICircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '../withStyles';
import styles from './CircularProgress.styles';
export const CircularProgress = ({ value, min = 0, max = 100, size = 20, color = 'default', classes, }) => (_jsx(MUICircularProgress, { className: classes[color], size: size, variant: value !== undefined ? 'determinate' : 'indeterminate', value: value !== undefined ? ((value - min) * 100) / (max - min) : undefined }));
export default withStyles(styles)(CircularProgress);
//# sourceMappingURL=CircularProgress.js.map